import SwatchFilter from '../components/SwatchFilter';
import { ITabs, ITab } from '../types/customizer';
import { getFilterMetaData, getSelectedOption, getWarning } from './commonRingUtils';
export const getV3InlayItems = (product: any) => {
  const items: ITabs = [
    {
      title: 'Material',
      helzberg_key: 'signet_inlay',
      label: 'Inlay Material',
      eventKey: 'inlays',
      component: SwatchFilter,
      isEnabled: product?.inlays?.inlay?.length > 0,
      content: {
        hasSwatch: true,
        fieldType: 'signet_inlay',
        options: product?.inlays?.inlay || [],
        selectedOption: getSelectedOption(product?.inlays?.inlay || [])
      }
    },
    {
      title: 'Finish',
      helzberg_key: 'signet_inlayfinish',
      label: 'Inlay Finish',
      eventKey: 'inlays_finish',
      component: SwatchFilter,
      isEnabled: product?.inlays?.inlayFinish?.length > 0,
      content: {
        hasSwatch: true,
        fieldType: 'signet_inlayfinish',
        options: product?.inlays?.inlayFinish,
        selectedOption: getSelectedOption(product?.inlays?.inlayFinish)
      }
    }
  ];
  const filtered = items.filter((tab: ITab) => tab.isEnabled || tab.items?.length);
  return filtered;
};
